import { buildQueryParams } from 'libs/utils'
import { trackHighlight } from './events'

export const name = 'facebook'

export const getShareUrl = (text, refUrl) => {
  const params = [
    ['quote', text],
    ['u', `${refUrl.origin}${refUrl.pathname}`],
  ]

  return `https://www.facebook.com/sharer/sharer.php?${buildQueryParams(
    params,
  )}`
}

export const action = () => trackHighlight('share-highlight-facebook')

export const render = (text, rawText, refUrl) => {
  const url = getShareUrl(text, refUrl)

  return `
    <a href="${url}" target="_blank" rel="noopener nofollow noreferrer">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M25.4892 5.33398H6.50256C6.19172 5.33624 5.89439 5.4613 5.67538 5.6819C5.45638 5.9025
        5.33349 6.20074 5.3335 6.51158V25.4982C5.33575 25.8091 5.46081 26.1064 5.68141 26.3254C5.90201
        26.5444 6.20025 26.6673 6.5111 26.6673H16.7298V18.4177H13.9564V15.1878H16.7298V12.8135C16.7298
        10.0593 18.413 8.54678 20.8706 8.54678C21.7 8.54325 22.5291 8.58598 23.3538
        8.67478V11.5633H21.6471C20.3138 11.5633 20.0556 12.2033 20.0556 13.1313V15.1878H23.2535L22.8268
        18.4177H20.0535V26.6673H25.4892C25.8015 26.6673 26.1011 26.5432 26.3219 26.3224C26.5428 26.1016
        26.6668 25.802 26.6668 25.4897V6.50305C26.6646 6.19221 26.5395 5.89487 26.3189 5.67587C26.0983
        5.45687 25.8001 5.33398 25.4892 5.33398V5.33398Z" fill="white"/>
      </svg>
    </a>
  `
}
